import {LanguageService} from '@gongxigames/framework/core';

export function getCurrentTime(): string {
    const date = new Date();

    return date.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hourCycle: 'h23'});
}

export function formatClockTime(milliseconds: number): string {
    const date = new Date(milliseconds);

    return date.toLocaleString('en-GB', {hour: 'numeric', minute: 'numeric', second: 'numeric', timeZone: 'UTC'});
}

export function getElapsedTime(from: number): number {
    return Date.now() - from;
}

export function dateDiffInSeconds(start: number, end: number): number {
    const diffInMs = end - start;

    return Math.floor(diffInMs / 1000);
}

export function formatDuration(durationInSeconds: number, languageService: LanguageService): string {
    const days = Math.floor(durationInSeconds / (60 * 60 * 24));
    const hours = Math.floor((durationInSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((durationInSeconds % (60 * 60)) / 60);
    const seconds = durationInSeconds % 60;
    const daysShort = days > 0 ? `${days}${languageService.get('daysShort')}` : '';
    const hoursShort = hours > 0 ? `${hours}${languageService.get('hoursShort')}` : '';
    const minutesShort = minutes > 0 ? `${minutes}${languageService.get('minutesShort')}` : '';
    const secondsShort = seconds > 0 ? `${seconds}${languageService.get('secondsShort')}` : '';
    const format = languageService.get('timeFormat', {daysShort, hoursShort, minutesShort, secondsShort});

    return format.trim();
}